// @ts-nocheck
import { Component, ElementRef, Input, OnInit, ViewChild, inject } from '@angular/core';
import { Router } from '@angular/router';
import { InjectableMaskCnj } from '../../../../../helpers/_old_helpers/masks/cnj';
import { BASE_SERVICE } from '../../../../../services/base.service';
import { LoadingComponent } from '../../../../_old_general-components/loading/loading.component';
import { TableComponent } from '../../../table/table.component';
import { Columns, Table } from '../../../table/table.model';
import { FormTemplateService } from '../form-template/form-template.service';

const tableHeader: Array<Columns> = [
  {
    name: 'id',
    type: 'data',
    label: 'Caso LB+',
    col: 3,
    enableCopy: true,
  },
  {
    name: 'externalId',
    type: 'data',
    label: 'N do Processo/Protocolo',
    col: 3,
    enableCopy: false,
  },
  {
    name: 'createdAt',
    type: 'data',
    label: 'Data de Criação',
    col: 3,
    enableCopy: true,
  },
  {
    name: 'status',
    type: 'data',
    label: 'Status do Caso',
    col: 3,
  },
];

@Component({
  selector: 'legalboxplus-linked-cases',
  templateUrl: './linked-cases.component.html',
  styleUrl: './linked-cases.component.scss',
  imports: [LoadingComponent, TableComponent],
})
export class LinkedCasesComponent implements OnInit {
  private processId;
  public loadPage = false;
  private flowIds;
  public clearSearchFunctionEs = null;
  public disabled;
  public feedback = false;

  @ViewChild('currentStatus', { static: true }) currentStatus!: ElementRef;

  @Input('properties') set configuration(properties) {}

  @Input('processId')
  set setProcessId(processId: any) {
    this.processId = processId;
  }

  @Input('origin') set disable(value) {
    if (value === 'task-form-complete') {
      this.disabled = true;
    }
  }
  public table: Table = {
    columns: [],
    body: [],
  };

  readonly baseService = inject(BASE_SERVICE);

  constructor(
    private router: Router,
    private formTemplateService: FormTemplateService,
    private maskCnj: InjectableMaskCnj
  ) {}

  ngOnInit() {
    this.getContextByUserIdAndCapability();

    this.search(this.table);

    if (!this.processId) {
      this.loadPage = true;
      return;
    }
  }

  search(table: Table) {
    this.feedback = true;
    this.baseService
      .getRuleBpmn({ processId: this.processId }, 'linkedCasesByCPF')
      .subscribe((body: any) => {
        this.loadPage = true;
        tableHeader.forEach((item) => {
          if (item.name === 'status') item.templateRef = this.currentStatus;
        });

        table.columns = tableHeader;
        body.data.forEach((element) => {
          element.status = element.preRegisterState || element.status;
          const processNumberLocal = element.processNumber || element.process_number;
          if (element.cnj) {
            const value = this.maskCnj.setMask(element.cnj, 0);
            element.cnjOrProcessNumber = value?.formatedValue;
          } else if (processNumberLocal) {
            element.cnjOrProcessNumber = processNumberLocal;
          }

          table.body = body.data;
        });
      });
    this.loadPage = false;
  }

  public async getContextByUserIdAndCapability() {
    const userId = localStorage.getItem('user-id');
    const params = {
      userId: userId ?? '',
      capabilityName: 'base/home',
    };
    this.baseService.getContextByuserIdAndCapability(params).subscribe((resp: any) => {
      this.flowIds = resp;
    });
  }

  public clickLine($event): void {
    this.router.navigate([]).then((result) => {
      window.open('/base/form/' + $event.id, '_blank');
    });
  }
}
